<template>
  <!-- begin login -->
  <div class="login login-with-news-feed">
    <!-- begin news-feed -->
    <div class="news-feed">
      <div
        class="news-image"
        :style="{
          'background-image': `url(${require('@/assets/login-bg-11.jpg')})`
        }"
      ></div>
    </div>
    <!-- end news-feed -->
    <!-- begin right-content -->
    <div class="right-content">
      <!-- begin login-header -->
      <div class="login-header">
        <div class="brand">
          <span class="logo"></span> <b>Money Exchange</b>
          <!-- <small>The number one point of sale solution</small> -->
        </div>
        <div class="icon">
          <i class="fa fa-sign-in"></i>
        </div>
      </div>
      <!-- end login-header -->
      <!-- begin login-content -->
      <div class="login-content">
        <form @submit.prevent="login" class="margin-bottom-0">
          <div class="form-group m-b-15">
            <input
              type="text"
              class="form-control form-control-lg"
              :class="{ 'is-invalid': errors.has('user_name') }"
              placeholder="username"
              v-model="user_name"
            />
            <div class="invalid-feedback" v-if="errors.has('user_name')">
              {{ errors.first('user_name') }}
            </div>
          </div>
          <div class="form-group m-b-15">
            <input
              type="password"
              class="form-control form-control-lg"
              :class="{ 'is-invalid': errors.has('password') }"
              placeholder="Password"
              v-model="password"
            />
            <div class="invalid-feedback" v-if="errors.has('password')">
              {{ errors.first('password') }}
            </div>
          </div>
          <div class="login-buttons">
            <button type="submit" class="btn btn-success btn-block btn-lg">
              Sign me in
            </button>
          </div>
          <hr class="m-t-40" />
          <p class="text-center text-grey-darker">
            &copy; Techstore All Right Reserved 2019
          </p>
        </form>
      </div>
      <!-- end login-content -->
    </div>
    <!-- end right-container -->
  </div>
  <!-- end login -->
</template>

<script>
import { Errors } from 'form-backend-validation'
import PageOptions from '../config/PageOptions.vue'

export default {
  name: 'Login',
  data() {
    return {
      user_name: null,
      password: null,
      errors: new Errors(),
      errorMessage: '',
      loggingIn: false
    }
  },
  created() {
    PageOptions.pageEmpty = true
    document.body.className = 'bg-white'
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    document.body.className = ''
    next()
  },
  methods: {
    async login() {
      this.loggingIn = true

      try {
        await this.$store.dispatch('login', {
          user_name: this.user_name,
          password: this.password
        })

        this.$router.push(this.$route.query.redirectTo || { name: 'home' })
      } catch (errorResponse) {
        this.errors = new Errors(errorResponse.errors)
        this.errorMessage = errorResponse.message
      }

      this.loggingIn = false
    }
  }
}
</script>
